module.exports = __webpack_public_path__ + "static/media/ben.ab11b41d.jpg";